import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import restaurants from './modules/restaurants'
import settings from './modules/settings'
import footerSocials from './modules/footerSocials'
import page from './modules/page'
import basket from './modules/basket'
import citiesList from './modules/citiesList'
import vacanciesList from "./modules/vacanciesList"

import {
  DELIVERY_METHOD_ADDRESS,
  DELIVERY_METHOD_SELF
} from '@/constants/deliveryMethods'

import {
  PAYMENT_METHOD_CASH,
  PAYMENT_METHOD_ONLINE,
  PAYMENT_METHOD_TERMINAL,
} from '@/constants/paymentMethods'

const deliveryMethods = [
  {
    id: DELIVERY_METHOD_ADDRESS,
    name: 'Доставка за адресою',
  },
  {
    id: DELIVERY_METHOD_SELF,
    name: 'Самовивіз',
  }
]

const paymentMethods = [
  {
    id: PAYMENT_METHOD_CASH,
    name: 'Оплата готівкою',
  },
  {
    id: PAYMENT_METHOD_ONLINE,
    name: 'Оплата онлайн',
  },
  {
    id: PAYMENT_METHOD_TERMINAL,
    name: 'Оплата через термінал',
  }
]

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    restaurants,
    settings,
    footerSocials,
    page,
    basket,
    citiesList,
    vacanciesList
  },
  state: {
    pending: false,
    key: 1,
    deliveryMethods,
    paymentMethods,
    maxIngredientsQuantity: 5,
    maxMainIngredientsQuantity: 5
  },
  mutations: {
    reset(state) {
      state.key += 1
    },
    setPending(state, value) {
      state.pending = value
    },
    setProperty(state, [key, value]) {
      state[key] = value
    }
  },
  actions: {
    reset({commit}) {
      commit('reset')
      commit('restaurants/resetState')
      commit('citiesList/resetState')
      commit('vacanciesList/resetState')
    }
  }
})

store.dispatch('settings/load')
store.dispatch('citiesList/load')
store.dispatch('user/init')
store.dispatch('footerSocials/setDefault')
store.dispatch('basket/subscribe')
store.dispatch('vacanciesList/load')

export default store
